// extracted by mini-css-extract-plugin
export default {"inputContainer":"buildingFlatNumber_inputContainer__8Ka7v"};